// src/tabs/DevicesTab.jsx
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Avatar,
  Chip,
  Divider,
  Button,
  IconButton,
} from "@mui/material";

import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import EventIcon from "@mui/icons-material/Event";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListAltIcon from "@mui/icons-material/ListAlt";

import { formatDate, moneyINR } from "../../../utils/helpers";
import { useOutletContext } from "react-router-dom";

/**
 * DevicesTab
 * - Works with API devices[]
 * - UI unchanged
 */
export default function DevicesTab() {
  const {
    devices = [],
    onRaiseClaim,
    onViewPurchase,
    onOpenDevice,
  } = useOutletContext();

  return (
    <Stack spacing={2}>
      <Typography fontWeight={900}>My Devices</Typography>

      {devices.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No devices found.
        </Typography>
      )}

      {devices.map((d) => (
        <Card
          key={d.id}
          sx={{
            borderRadius: 4,
            cursor: "pointer",
            transition: "transform 120ms ease",
            "&:hover": { transform: "translateY(-1px)" },
          }}
          onClick={() => onOpenDevice?.(d.id)}
        >
          <CardContent>
            {/* HEADER */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar sx={{ bgcolor: "#eef2ff" }}>
                <PhoneIphoneIcon color="primary" />
              </Avatar>

              <Stack flex={1}>
                <Typography fontWeight={900}>
                  {d.product_name || "Device"}
                </Typography>

                <Typography variant="caption" color="text.secondary">
                  {d.brand_name || "—"} • {d.category_name || "—"}
                </Typography>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mt: 0.8 }}
                >
                  <Chip
                    size="small"
                    label={d.is_approved ? "Warranty Active" : "Inactive"}
                    color={d.is_approved ? "success" : "default"}
                  />

                  <Chip
                    size="small"
                    variant="outlined"
                    label={`Claims Left: ${d.available_claim ?? 0}`}
                  />
                </Stack>
              </Stack>

              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenDevice?.(d.id);
                }}
              >
                <ChevronRightIcon />
              </IconButton>
            </Stack>

            <Divider sx={{ my: 2 }} />

            {/* DEVICE INFO */}
            <Stack spacing={0.6}>
              <Stack direction="row" spacing={1} alignItems="center">
                <EventIcon fontSize="small" />
                <Typography variant="body2" color="text.secondary">
                  Warranty Expiry:{" "}
                  <b>
                    {d.expiry_date
                      ? formatDate(d.expiry_date)
                      : "—"}
                  </b>
                </Typography>
              </Stack>

              <Typography variant="caption" color="text.secondary">
                S/N: {d.serial || "—"}
                {d.imei1 && ` • IMEI1: ${d.imei1}`}
                {d.imei2 && ` • IMEI2: ${d.imei2}`}
              </Typography>

              <Typography variant="caption" color="text.secondary">
                Warranty Code: {d.w_code || "—"}
              </Typography>
            </Stack>

            {/* STATS */}
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <Card sx={{ flex: 1, borderRadius: 3 }}>
                <CardContent sx={{ py: 1.3 }}>
                  <Typography variant="caption" color="text.secondary">
                    Device Price
                  </Typography>
                  <Typography fontWeight={900}>
                    {moneyINR(d.device_price || 0)}
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{ flex: 1, borderRadius: 3 }}>
                <CardContent sx={{ py: 1.3 }}>
                  <Typography variant="caption" color="text.secondary">
                    Claim Balance
                  </Typography>
                  <Typography fontWeight={900}>
                    {d.available_claim ?? 0}
                  </Typography>
                </CardContent>
              </Card>
            </Stack>

            {/* ACTIONS */}
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <Button
                size="small"
                variant="outlined"
                startIcon={<ListAltIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  onViewPurchase?.(d.id);
                }}
              >
                View Purchase
              </Button>

              <Button
                size="small"
                variant="contained"
                sx={{ ml: "auto" }}
                onClick={(e) => {
                  e.stopPropagation();
                  onRaiseClaim?.(d.id);
                }}
              >
                Raise Claim
              </Button>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}


// // src/tabs/DevicesTab.jsx
// import React, { useMemo } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Stack,
//   Avatar,
//   Chip,
//   Divider,
//   Button,
//   IconButton,
// } from "@mui/material";

// import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
// import StoreIcon from "@mui/icons-material/Store";
// import EventIcon from "@mui/icons-material/Event";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ListAltIcon from "@mui/icons-material/ListAlt";
// import { formatDate, moneyINR } from "../../../utils/helpers";
// import { useOutletContext } from "react-router-dom";


// /**
//  * DevicesTab
//  * - Shows all devices
//  * - Coverage + balances
//  * - Claim stats
//  * - Entry point for Device Details
//  */
// export default function DevicesTab() {

//   const {
//     devices,
//     onRaiseClaim,
//     onViewPurchase,
//     onOpenDevice,
//   } = useOutletContext();


//   const getPurchaseById = (id) =>
//     purchases.find((p) => p.id === id);

//   return (
//     <Stack spacing={2}>
//       <Typography fontWeight={900}>My Devices</Typography>

//       {devices.map((d) => {
//         const pur = getPurchaseById(d.purchase_id);

//         return (
//           <Card
//             key={d.id}
//             sx={{
//               borderRadius: 4,
//               cursor: "pointer",
//               transition: "transform 120ms ease",
//               "&:hover": { transform: "translateY(-1px)" },
//             }}
//           >
//             <CardContent>
//               {/* HEADER */}
//               <Stack direction="row" spacing={2} alignItems="center">
//                 <Avatar sx={{ bgcolor: "#eef2ff" }}>
//                   <PhoneIphoneIcon color="primary" />
//                 </Avatar>

//                 <Stack flex={1}>
//                   <Typography fontWeight={900}>
//                     {d.name}
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     color="text.secondary"
//                   >
//                     {d.plan}
//                   </Typography>

//                   <Stack
//                     direction="row"
//                     spacing={1}
//                     alignItems="center"
//                     sx={{ mt: 0.8 }}
//                   >
//                     <Chip
//                       size="small"
//                       label={d.status}
//                       color={d.statusColor}
//                     />
//                     <Chip
//                       size="small"
//                       variant="outlined"
//                       label={`Claims: ${d.claims_done}`}
//                     />
//                   </Stack>
//                 </Stack>

//                <IconButton
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     onOpenDevice?.(d.id);
//                   }}
//                 >
//                   <ChevronRightIcon />
//                 </IconButton>

//               </Stack>

//               <Divider sx={{ my: 2 }} />

//               {/* PURCHASE INFO */}
//               <Stack spacing={0.6}>
//                 <Stack
//                   direction="row"
//                   spacing={1}
//                   alignItems="center"
//                 >
//                   <StoreIcon fontSize="small" />
//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                   >
//                     Purchased from{" "}
//                     <b>{pur?.purchased_from?.name || "—"}</b>
//                   </Typography>
//                 </Stack>

//                 <Stack
//                   direction="row"
//                   spacing={1}
//                   alignItems="center"
//                 >
//                   <EventIcon fontSize="small" />
//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                   >
//                     {formatDate(pur?.purchase_date)} •
//                     Order No:{" "}
//                     <b>{pur?.order_no || "—"}</b>
//                   </Typography>
//                 </Stack>

//                 <Typography
//                   variant="caption"
//                   color="text.secondary"
//                 >
//                   S/N: {pur?.serial_no || "—"}
//                   {pur?.imei &&
//                     ` • IMEI: ${pur.imei}`}
//                   {pur?.warranty_expiry &&
//                     ` • Expiry: ${formatDate(
//                       pur.warranty_expiry
//                     )}`}
//                 </Typography>
//               </Stack>

//               {/* STATS */}
//               <Stack
//                 direction="row"
//                 spacing={1}
//                 sx={{ mt: 2 }}
//               >
//                 <Card sx={{ flex: 1, borderRadius: 3 }}>
//                   <CardContent sx={{ py: 1.3 }}>
//                     <Typography
//                       variant="caption"
//                       color="text.secondary"
//                     >
//                       Cover Balance
//                     </Typography>
//                     <Typography fontWeight={900}>
//                       {moneyINR(d.cover_balance)}
//                     </Typography>
//                   </CardContent>
//                 </Card>

//                 <Card sx={{ flex: 1, borderRadius: 3 }}>
//                   <CardContent sx={{ py: 1.3 }}>
//                     <Typography
//                       variant="caption"
//                       color="text.secondary"
//                     >
//                       Claim Balance
//                     </Typography>
//                     <Typography fontWeight={900}>
//                       {d.claim_balance}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Stack>

//               {/* ACTIONS */}
//               <Stack
//                 direction="row"
//                 spacing={1}
//                 sx={{ mt: 2 }}
//               >
//                 <Button
//                   size="small"
//                   variant="outlined"
//                   startIcon={<ListAltIcon />}
//                   onClick={(e) => {
//                     e.stopPropagation();        // 🔥 prevent card click
//                     onViewPurchase?.(d.purchase_id);
//                   }}
//                 >
//                   View Purchase
//                 </Button>


//                 <Button
//                   size="small"
//                   variant="contained"
//                   sx={{ ml: "auto" }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     onRaiseClaim?.(d.id);
//                   }}
//                 >
//                   Raise Claim
//                 </Button>
//               </Stack>
//             </CardContent>
//           </Card>
//         );
//       })}
//     </Stack>
//   );
// }
